/**
 * Setup Builder — static reference data.
 *
 * weightSizeTable is the Twelve Board Store weight → board size chart.
 * Matching logic rounds to the NEAREST listed weightKg row — it does not
 * interpolate between rows.
 */
window.SetupBuilderConfig = {
  weightSizeTable: [
    { weightKg: 27, avgLengthCm: 95, minLengthCm: 90, maxLengthCm: 100 },
    { weightKg: 32, avgLengthCm: 110, minLengthCm: 105, maxLengthCm: 115 },
    { weightKg: 36, avgLengthCm: 120, minLengthCm: 115, maxLengthCm: 125 },
    { weightKg: 41, avgLengthCm: 130, minLengthCm: 125, maxLengthCm: 135 },
    { weightKg: 45, avgLengthCm: 138, minLengthCm: 135, maxLengthCm: 140 },
    { weightKg: 50, avgLengthCm: 141, minLengthCm: 138, maxLengthCm: 144 },
    { weightKg: 54, avgLengthCm: 143, minLengthCm: 140, maxLengthCm: 146 },
    { weightKg: 59, avgLengthCm: 146, minLengthCm: 142, maxLengthCm: 148 },
    { weightKg: 63, avgLengthCm: 147, minLengthCm: 144, maxLengthCm: 149 },
    { weightKg: 68, avgLengthCm: 149, minLengthCm: 146, maxLengthCm: 152 },
    { weightKg: 73, avgLengthCm: 151, minLengthCm: 148, maxLengthCm: 154 },
    { weightKg: 77, avgLengthCm: 154, minLengthCm: 151, maxLengthCm: 157 },
    { weightKg: 82, avgLengthCm: 155, minLengthCm: 152, maxLengthCm: 158 },
    { weightKg: 86, avgLengthCm: 156, minLengthCm: 153, maxLengthCm: 159 },
    { weightKg: 91, avgLengthCm: 158, minLengthCm: 155, maxLengthCm: 161 },
    { weightKg: 95, avgLengthCm: 160, minLengthCm: 157, maxLengthCm: 163 },
    { weightKg: 100, avgLengthCm: 162, minLengthCm: 158, maxLengthCm: 165 },
    { weightKg: 105, avgLengthCm: 163, minLengthCm: 159, maxLengthCm: 167 },
    { weightKg: 110, avgLengthCm: 164, minLengthCm: 160, maxLengthCm: 168 }
  ],

  // Natural-language phrasing for raw enum values, used when building
  // per-board recommendation copy. Keep to short lowercase fragments so
  // they slot into sentences grammatically.
  descriptors: {
    terrain: {
      "all-mountain": "everything from groomers to the odd powder day",
      park: "park laps and jumps",
      freeride: "fast, technical terrain",
      powder: "deep powder days",
      resort: "everyday resort riding"
    },
    skill_level: {
      beginner: "still finding your feet",
      intermediate: "comfortable linking turns and looking to push further",
      advanced: "riding aggressively and wanting a board that keeps up"
    },
    shape: {
      twin: "playful and symmetrical, equally happy either direction",
      "directional twin": "a slight directional bias with twin-ish playfulness",
      directional: "built to be ridden one way, for drive and stability",
      "volume shifted": "shorter and wider for float without the extra length"
    },
    product_line: {
      mens: "men's",
      womens: "women's",
      unisex: "unisex"
    },
    lacing_system: {
      boa: "a quick-turn Boa dial for on-the-fly adjustment",
      laces: "traditional laces for a fully custom, all-day fit",
      "speed lace": "a speed-lace pull system for fast in-out",
      hybrid: "a hybrid lacing setup blending laces and Boa"
    },
    entry_system: {
      "step on": "Step On compatible for quick, binding-free entry",
      traditional: "a traditional strap-in entry"
    }
  }
};